import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SidebarAnchors from "../../components/layout/SidebarAnchors"; // adjust path as needed

const ProjectUpdates = () => {
  const theme = useTheme();
  const updates = [
    {
      anchor: "oct-2026",
      date: "October 14, 2026",
      title: "Now Fansite Certified!",
      content: (<>
        We are happy to announce that we are now officially a certified fan site by TNT! <Link href="/updates/oct-2026" sx={{ color: theme.palette.accent.main }}><strong>View full update</strong></Link>
      </>)
    },
    {
      anchor: "june-2026",
      date: "June 9, 2026",
      title: "Happy One Year!",
      content: (<>
        Let's celebrate our upcoming one year anniversary as a value guide! Time just flies doesn't it? June 23rd marks our official birthday, and we have some exciting news to share! <Link href="/updates/june-2026" sx={{ color: theme.palette.accent.main }}><strong>View full update</strong></Link>
      </>)
    },
    {
      anchor: "nov-2025",
      date: "November 15, 2025",
      title: "Token Search + More!",
      content: (<>
        Based on feedback over the last two months, we've added some new features and content to help with your trading experience. Please welcome our new <Link href="/token-search" sx={{ color: theme.palette.primary.main }}>token search</Link> and our guide on <Link href="/guides/token-trading" sx={{ color: theme.palette.primary.main }}>token trading</Link>. We know token trading can be really confusing, so we hope these can give you some more direction... <Link href="/updates/nov-2025" sx={{ color: theme.palette.accent.main }}><strong>View full update</strong></Link>
      </>)
    },
    {
      anchor: "sept-2025",
      date: "September 29, 2025",
      title: "We've launched!",
      content: (<>
        After quite some time in planning and development, we are proud to officially launch the Stylisher site! Our focus is on being a NC Trading resource site for the NC community on Neopets as navigating the world of NC can easily get complicated. We've started by putting up a few articles and guides that you can access from our <Link href="/resource-hub" sx={{ color: theme.palette.primary.main }}>resource hub</Link> in addition to the existing value guide that we run. Please feel free to explore the site... <Link href="/updates/sept-2025" sx={{ color: theme.palette.accent.main }}><strong>View full update</strong></Link>
      </>)
    }
  ];

  const anchorSections = updates.map(update => ({
    id: update.anchor,
    title: update.date
  }));

  return (
    <Container maxWidth="lg" sx={{ py: 6, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
      {/* Sidebar Anchors */}
      <Box sx={{ flex: 1, display: { xs: 'none', md: 'block' } }}>
        <SidebarAnchors sections={anchorSections} />
      </Box>

      {/* Main Content */}
      <Box sx={{ flex: 3 }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 600, color: theme.palette.accent.main }}>
          Site Updates
        </Typography>

        {updates.map((update, index) => (
          <Box key={update.date} id={update.anchor} sx={{ mb: 3, p: 2, background: theme.palette.background.paper, borderRadius: 5 }}>
            <Typography variant="h6" color={theme.palette.text.secondary} gutterBottom>
              {update.date}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: theme.palette.secondary.main }}>
              {update.title}
            </Typography>
            <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
              {update.content}
            </Typography>
          </Box>
        ))}
      </Box>


    </Container>
  );
};

export default ProjectUpdates;
